import { useEffect } from 'react';
import { IMaterial } from '@/_types';
import { articleViewEvent } from '@/_analytic/events/article-view-event';
import { TAnalyticEventParams } from '@/_analytic/_types';
import { useHelpCenterType } from '@/_hooks/use-help-center-type';
import { useMaterialAnalyticData } from '@/_analytic/hooks/use-material-analytic-data';

type TProps = {
  material: IMaterial;
  idsRecommendBlock: TAnalyticEventParams['idsRecommendBlock'];
  byAnchorLink: TAnalyticEventParams['byAnchorLink'];
};

export const useAnalytic = ({
  material,
  idsRecommendBlock,
  byAnchorLink,
}: TProps) => {
  const isRecommendBlock = idsRecommendBlock === 'no' ? 'false' : 'true';

  const helpCenterType = useHelpCenterType();
  const materialAnalyticData = useMaterialAnalyticData({
    materialTitle: material.title,
    materialId: material.id,
    materialCategoryId: material.categoryIds?.[0] ?? '',
  });

  useEffect(() => {
    const canSendAnalytic =
      !materialAnalyticData.isLoading &&
      material.id &&
      material.title &&
      idsRecommendBlock !== 'isLoading';

    if (canSendAnalytic) {
      articleViewEvent({
        ...materialAnalyticData,
        isAvailableOnlyByLink: material.drawerOnly,
        isRecommendBlock,
        idsRecommendBlock,
        byAnchorLink,
      });
    }
  }, [
    byAnchorLink,
    helpCenterType,
    idsRecommendBlock,
    isRecommendBlock,
    material.drawerOnly,
    material.id,
    material.title,
    materialAnalyticData,
  ]);
};
